module.exports = __webpack_public_path__ + "static/media/29DUNON6.b4cc9aa9.jpg";